import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { LOCALSTORAGE_TOKEN_SPONSOR } from "../../Constants";
import { useGlobalState } from "state-pool";
import { BRAND, BRAND_SOFT, BG_CANVAS, TEXT, BORDER, PictX } from "../../Pages/Sponsor/adminShared";

const NAV = [
  { name: "店舗一覧", href: "/sponsor/hubs" },
  { name: "クーポン使用状況", href: "/sponsor/hubs/coupon/used" },
  { name: "Boomin'トップ", href: "/" },
];

const Brand = () => (
  <a
    href="/sponsor"
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 9,
      textDecoration: "none",
      color: TEXT,
      fontSize: 19,
      fontWeight: 800,
      letterSpacing: "-0.01em",
    }}
  >
    <span
      style={{
        width: 28,
        height: 28,
        borderRadius: 9,
        background: BRAND,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <PictX name="walk" size={16} stroke="#fff" strokeWidth={2} />
    </span>
    Boomin<span style={{ color: BRAND }}>'</span>
    <span style={{ fontSize: 13, fontWeight: 700, color: "#8A7E74" }}>加盟店</span>
  </a>
);

export const Header = () => {
  const history = useHistory();
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useGlobalState("loggedInSponsor");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN_SPONSOR);
    setLoggedIn(token == null ? false : true);
  }, [setLoggedIn]);

  const logout = () => {
    localStorage.removeItem(LOCALSTORAGE_TOKEN_SPONSOR);
    setLoggedIn(false);
    history.push("/sponsor/login");
  };

  const isActive = (href: string) =>
    href.startsWith("/sponsor") && location.pathname.startsWith(href);

  const navLinkStyle = (href: string) => ({
    fontSize: 14,
    fontWeight: 700 as const,
    textDecoration: "none",
    color: isActive(href) ? BRAND : "#5C5249",
    padding: "6px 0",
    borderBottom: isActive(href) ? `2px solid ${BRAND}` : "2px solid transparent",
  });

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 30,
        background: "rgba(255,251,247,0.92)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: `1px solid ${BORDER}`,
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "14px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        <Brand />

        {!loggedIn ? (
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <a
              href="/sponsor/login"
              style={{ fontSize: 14, fontWeight: 700, color: "#5C5249", textDecoration: "none" }}
            >
              ログイン
            </a>
            <a
              href="/sponsor/signup"
              style={{
                fontSize: 14,
                fontWeight: 800,
                color: "#fff",
                background: BRAND,
                borderRadius: 999,
                padding: "9px 18px",
                textDecoration: "none",
                boxShadow: "0 8px 18px rgba(255,77,45,0.28)",
              }}
            >
              新規登録
            </a>
          </div>
        ) : (
          <>
            {/* Desktop nav */}
            <nav className="hidden md:flex" style={{ alignItems: "center", gap: 28 }}>
              {NAV.map((e) => (
                <a key={e.href} href={e.href} style={navLinkStyle(e.href)}>
                  {e.name}
                </a>
              ))}
              <button
                onClick={logout}
                style={{
                  fontSize: 14,
                  fontWeight: 800,
                  color: BRAND,
                  background: BRAND_SOFT,
                  border: 0,
                  borderRadius: 999,
                  padding: "9px 18px",
                  cursor: "pointer",
                }}
              >
                ログアウト
              </button>
            </nav>

            {/* Mobile toggle */}
            <button
              className="md:hidden"
              aria-label="メニュー"
              onClick={() => setMenuOpen((v) => !v)}
              style={{
                width: 38,
                height: 38,
                borderRadius: 999,
                border: `1px solid ${BORDER}`,
                background: menuOpen ? BRAND_SOFT : "#fff",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke={menuOpen ? BRAND : TEXT} strokeWidth="1.9" strokeLinecap="round">
                {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
              </svg>
            </button>
          </>
        )}
      </div>

      {/* Mobile menu panel */}
      {loggedIn && menuOpen && (
        <nav
          className="md:hidden"
          style={{
            borderTop: `1px solid ${BORDER}`,
            background: BG_CANVAS,
            padding: "8px 12px 14px",
          }}
        >
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "12px 10px",
                borderRadius: 10,
                textDecoration: "none",
                color: TEXT,
                fontSize: 15,
                fontWeight: 700,
              }}
            >
              {item.name}
            </a>
          ))}
          <button
            onClick={logout}
            style={{
              width: "100%",
              marginTop: 8,
              padding: "12px",
              borderRadius: 12,
              border: 0,
              background: BRAND,
              color: "#fff",
              fontSize: 15,
              fontWeight: 800,
              cursor: "pointer",
            }}
          >
            ログアウト
          </button>
        </nav>
      )}
    </header>
  );
};
